export default __webpack_public_path__ + "static/icon-phone-peach-09dca125a1f4a9c10c4ac2f5d56a89bc.png";